export default __webpack_public_path__ + "static/media/hall_of_fame_header_one.36bfe113.png";